import * as token from '@thiememeulenhoff/tokens/core';

export const config = {
  general: {
    usePost: true,
    cookieName: 'ReadSpeakerSettings',
    skipHiddenContent: true,
  },
  settings: {
    hlword: token.ColorOrange300,
    hlsent: token.ColorBlue200,
    hltext: token.ColorBlack,
    hlicon: 'iconoff',
    hlscroll: 'scrollon',
    hlspeed: 100,
  },
  ui: {
    autoscrollOffset: 0,
    preventLightboxResize: true,
    displayDownload: false,
    disableDetachment: true,
  },
};
